<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body{
  margin: 0px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.page-container{
  height: 100vh;
}
.el-container{
  min-height: 100vh;
}
.el-header{
  line-height: 50px;
}
body > .el-container{
  margin-bottom: 40px;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
width: 8px;
/*滚动条宽度*/
height: 8px;
/*滚动条高度*/
} /*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
border-radius: 10px;
/*滚动条的背景区域的圆角*/
background-color: #fff;
/*滚动条的背景颜色*/
} /*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
border-radius: 10px;
/*滚动条的圆角*/
-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .1);
background-color: #dfe1e3;
/*滚动条的背景颜色*/
}
.text-overflow{
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .multiline-overflow{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue